import React, { useState, useEffect } from "react";
import { Box, CircularProgress, Tab, Tabs } from "@mui/material";
import AppHeaderBar from "../../components/AppBar/appBar";
import AdminRibbion from "./AdminRibbion";
import AdminBadge from "./AdminBadge";
import AdminBrand from "./AdminBrand";
import AdminBusinessNature from "./AdminBusinessNature";
import AdminProduct from "./AdminProduct";
import AdminCategory from "./AdminCategory";
import AdminSubcategory from "./AdminSubcategory";
import AdminProductVariants from "./AdminProductVariants";
import Adminvariantproperties from "./Adminvariantproperties";
import { useSelector } from "react-redux";
// import { useFetch } from "../../hooks/useFetch";
import { useFetch } from "../../hooks";
import { urls } from "../../urls/urls";
import { BASE_URL_TEST } from "../../utils/baseUrl";
import AdminVendorProduct from "./AdminVendorProduct";
import AdminListingCategory from "./AdminListingCategory";
import AdminListingProduct from "./AdminListingProduct";

export default function AdminProductManagement({ onBackScreenName }) {
  const [selectedTab, setSelectedTab] = useState(0);
  const loginToken = useSelector((state) => state.user.logintoken);
  console.log("cllaed");
  console.log("logintoken", loginToken);
  const [allBNatureList, setBNatureList] = useState([]);
  const {
    data: allBNatureData,
    error: allBNatureError,
    isLoading: isLoadingBNature,
    fetchData: allBNatureFetchData,
  } = useFetch(BASE_URL_TEST + urls("getAllBNature"), {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  useEffect(() => {
    if (loginToken) {
      allBNatureFetchData();
    } else {
      // navigate('/sal')
      console.log("login token empty");
    }
  }, []);

  useEffect(() => {
    if (allBNatureError) {
    } else if (allBNatureData && allBNatureData["status"] === true) {
      console.log("data", allBNatureData["data"]);
      setBNatureList(allBNatureData["data"]);
    }
  }, [allBNatureData, allBNatureError]);

  const handleScreeName = (sname) => {
    onBackScreenName(sname);
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 3,
        p: 2,
        bgcolor: "#EEF2FF",
      }}
    >
      {/* Header */}
      <AppHeaderBar
        title={" Product Management"}
        onBackScreenName={handleScreeName}
      />

      {/* Tabs Section */}
      <Tabs
        value={selectedTab}
        onChange={handleTabChange}
        sx={{
          // backgroundColor: "white",
          borderBottom: "1px solid #ddd",
          color: "black",
        }}
        indicatorColor="primary"
        textColor="primary"
        variant="scrollable"
        scrollButtons="auto"
      >
        <Tab label="Business nature" sx={{ textTransform: "none" }} />
        <Tab label="Brand" sx={{ textTransform: "none" }} />
        <Tab label="Ribbon" sx={{ textTransform: "none" }} />
        <Tab label="Badge" sx={{ textTransform: "none" }} />
        <Tab label="Category" sx={{ textTransform: "none" }} />
        <Tab label="Sub category" sx={{ textTransform: "none" }} />
        <Tab label="Variants" sx={{ textTransform: "none" }} />
        <Tab label="Variants properties" sx={{ textTransform: "none" }} />
        <Tab label="Product" sx={{ textTransform: "none" }} />
        <Tab label="Vendor Products" sx={{ textTransform: "none" }} />
        <Tab label="Listing Category" sx={{ textTransform: "none" }} />
        <Tab label="Listing Products" sx={{ textTransform: "none" }} />
      </Tabs>

      {selectedTab === 0 && (
        <Box>
          {isLoadingBNature ? (
            <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
              <CircularProgress />
            </Box>
          ) : (
            <AdminBusinessNature
              data={allBNatureList}
              refreshData={allBNatureFetchData}
            />
          )}
        </Box>
      )}

      {selectedTab === 1 && (
        <>
          <AdminBrand />
        </>
      )}

      {selectedTab === 2 && (
        <>
          <AdminRibbion />
        </>
      )}

      {selectedTab === 3 && (
        <>
          <AdminBadge />
        </>
      )}

      {selectedTab === 4 && (
        <>
          <AdminCategory />
        </>
      )}
      {selectedTab === 5 && (
        <>
          <AdminSubcategory />
        </>
      )}

      {selectedTab === 6 && (
        <>
          <AdminProductVariants />
        </>
      )}
      {selectedTab === 7 && (
        <>
          <Adminvariantproperties />
        </>
      )}

      {selectedTab === 8 && (
        <>
          <AdminProduct />
        </>
      )}
      {selectedTab === 9 && (
        <>
          <AdminVendorProduct />
        </>
      )}
      {selectedTab === 10 && (
        <>
          <AdminListingCategory />
        </>
      )}
      {selectedTab === 11 && (
        <>
          <AdminListingProduct />
        </>
      )}
    </Box>
  );
}
